<div class="clinic-notification-popup">
  <form [formGroup]="notificationForm" class="notification-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Clinique à notifier</mat-label>
      <mat-select formControlName="clinicId" required>
        <mat-option *ngFor="let clinic of clinics" [value]="clinic.id">
          {{ clinic.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Message de la notification</mat-label>
      <textarea matInput formControlName="message" placeholder="Saisissez votre message..." rows="4"
        maxlength="255">
      </textarea>
      <mat-hint align="end">{{ messageControl?.value?.length || 0 }}/255</mat-hint>
      <mat-error *ngIf="messageControl?.invalid && messageControl?.touched">
        {{ messageErrorText }}
      </mat-error>
    </mat-form-field>
    <div class="checkbox-field">
      <mat-checkbox formControlName="targets">
        Notifier seulement les vétérinaires ? (Défaut = tous les utilisateurs)
      </mat-checkbox>
    </div>
  </form>
</div>